import React from "react";
export default ({ currentPage, onClick }) => (
  <a
    {...{
      className: "pagination-previous",
      disabled: currentPage <= 1,
      onClick: currentPage <= 1 ? undefined : onClick(--currentPage)
    }}
  >
    Previous page
  </a>
);



// WEBPACK FOOTER //
// ./src/components/Pagination/PreviousPage.js